import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { propStr } from '../../../../../../../helpers/custom-prop-types';
import DateText from '../../../../../../Ui/Common/DateText';
import Image from '../../../../../../Ui/Common/Image';
const ProffitSearchFolderShareCommentProfile = (props) => {
    const { className, createdAt, dateFormatSuffix, name, photo } = props;
    return (_jsxs("div", Object.assign({ className: clsx('proffit_search_folder_share_comment_profile', className) }, { children: [_jsx("div", Object.assign({ className: 'profile_left' }, { children: _jsx(Image, { alt: '', isGrayScale: true, isObjectFit: true, noImageType: 'user', src: photo, useImage: true }) })), _jsxs("div", Object.assign({ className: 'profile_right' }, { children: [_jsx("div", Object.assign({ className: 'right_name' }, { children: name })), createdAt && (_jsx("div", Object.assign({ className: 'right_date' }, { children: _jsx(DateText, { format: `YYYY / M / D に${dateFormatSuffix}`, value: createdAt }) })))] }))] })));
};
ProffitSearchFolderShareCommentProfile.propTypes = {
    className: propStr(),
    createdAt: propStr(),
    dateFormatSuffix: propStr().isRequired,
    name: propStr().isRequired,
    photo: propStr(),
};
ProffitSearchFolderShareCommentProfile.defaultProps = {
    className: '',
    createdAt: '',
    photo: '',
};
export default ProffitSearchFolderShareCommentProfile;
